import{
    EDIT_PASSWORD_FAIL,
    EDIT_PASSWORD_REQUEST,
    EDIT_PASSWORD_SUCCESS,
    EDIT_PASSWORD_RESET
} from '../constants/resetPasswordConstants'




const InitialState = {
    loading: false,
    error: null,
    success: false,
  };

  export const editPasswordReducer = (state = InitialState, action) => {
    switch (action.type) {
      case EDIT_PASSWORD_REQUEST:
        return { ...state, loading: true };
      case EDIT_PASSWORD_SUCCESS:
        return { 
          ...state, 
          loading: false,
           success: true,
            player: action.payload };
      case EDIT_PASSWORD_FAIL:
        return {...state, loading: false, error: action.payload };
        case EDIT_PASSWORD_RESET: 
        return InitialState;
      default:
        return state;
    }
  };
 